// HAWELO — products + collections data hook (Shopify Storefront)
import { useState, useEffect } from 'react';
import {
  storefront,
  Q_PRODUCTS,
  Q_PRODUCT_BY_HANDLE,
  Q_COLLECTIONS,
  Q_COLLECTION_BY_HANDLE,
  flattenEdges,
  normaliseProduct,
} from './shopify';

export function useProducts(first = 24) {
  const [state, setState] = useState({ products: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await storefront(Q_PRODUCTS, { first });
        const items = flattenEdges(data.products).map(normaliseProduct);
        if (!cancelled) setState({ products: items, loading: false, error: null });
      } catch (e) {
        if (!cancelled) setState({ products: [], loading: false, error: e.message });
      }
    })();
    return () => { cancelled = true; };
  }, [first]);

  return state;
}

export function useProduct(handle) {
  const [state, setState] = useState({ product: null, loading: true, error: null });

  useEffect(() => {
    if (!handle) return;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));
    (async () => {
      try {
        const data = await storefront(Q_PRODUCT_BY_HANDLE, { handle });
        if (!cancelled) setState({ product: normaliseProduct(data.product), loading: false, error: null });
      } catch (e) {
        if (!cancelled) setState({ product: null, loading: false, error: e.message });
      }
    })();
    return () => { cancelled = true; };
  }, [handle]);

  return state;
}

export function useCollections(first = 20) {
  const [state, setState] = useState({ collections: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await storefront(Q_COLLECTIONS, { first });
        if (!cancelled) setState({ collections: flattenEdges(data.collections), loading: false, error: null });
      } catch (e) {
        if (!cancelled) setState({ collections: [], loading: false, error: e.message });
      }
    })();
    return () => { cancelled = true; };
  }, [first]);

  return state;
}

export function useCollection(handle, first = 24) {
  const [state, setState] = useState({ collection: null, loading: true, error: null });

  useEffect(() => {
    if (!handle) return;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));
    (async () => {
      try {
        const data = await storefront(Q_COLLECTION_BY_HANDLE, { handle, first });
        const col = data.collection
          ? {
              ...data.collection,
              products: flattenEdges(data.collection.products).map(normaliseProduct),
            }
          : null;
        if (!cancelled) setState({ collection: col, loading: false, error: null });
      } catch (e) {
        if (!cancelled) setState({ collection: null, loading: false, error: e.message });
      }
    })();
    return () => { cancelled = true; };
  }, [handle, first]);

  return state;
}
